import React from 'react'
import { useContext } from './Context'
import { ShowIf } from '@ztechapps/webui.util'
import { InlineDisplayContent, NumberInput } from '@ztechapps/webui.input'
import { PaidAndBalanceAmount } from '../PaidAndBalanceAmount'
import { IsPartialCheckbox } from '../IsPartialCheckbox'
import { useCheckoutContext } from '../../../index'

export const CashPartial = () => {
  const context = useCheckoutContext()
  const hasPartialPayment = context.hasPartialPayments
  const { amount, setAmount, isPartial, errors, balance } = useContext()

  return (
    <ShowIf condition={hasPartialPayment}>
      <IsPartialCheckbox />

      <ShowIf condition={isPartial}>
        <PaidAndBalanceAmount />

        <div className={'row'}>
          <div className={'col-md-4'}>
            <InlineDisplayContent label={'Amount'} meta={{ touched: errors?.amount, error: errors?.amount }}>
              <NumberInput
                min={0}
                disabled={balance <= 0}
                value={amount}
                onChange={(e) => {
                  setAmount(e?.target?.value)
                }}
              />
            </InlineDisplayContent>
          </div>
        </div>
      </ShowIf>
    </ShowIf>
  )
}
